export const SEARCH_THROTTLE_TIME = 1000 * 60 * 5;
export const SEARCH_INPUT_HEIGHT = 59;
export const TOP_AREA_BORDER_BOTTOM = 2;
// Should correspond to the height of the "See all results" button in the search preview
export const SEARCH_PREVIEW_SEE_ALL_HEIGHT = 51;

export const TOP_AREA_BANNER_HEIGHT = 34;
export const TOP_NAV_HEIGHT_CSS_VARIABLE = '--top-nav-height';
export const TOP_NAV_INNER_HEIGHT_CSS_VARIABLE = '--top-nav-inner-height';
// Must have the same value as `--top-nav-height-animation` in `.top-nav` in `packages/top-area/src/App.css`
export const CSS_HEIGHT_ANIMATION = 'var(--top-nav-height-animation, 0.3s ease-in-out)';

// Must have the same value as  `--top-nav-height` and `--top-nav-inner-height` in `.top-nav` in `packages/top-area/src/App.css`
export const DESKTOP_HEIGHT = 64;
export const CSS_DESKTOP_HEIGHT = `var(${TOP_NAV_HEIGHT_CSS_VARIABLE}, ${DESKTOP_HEIGHT}px)`;
export const CSS_DESKTOP_INNER_HEIGHT = `var(${TOP_NAV_INNER_HEIGHT_CSS_VARIABLE}, ${DESKTOP_HEIGHT}px)`;

// Must have the same value as `--top-nav-height` in `.top-nav--with-top-area-banner` in `packages/top-area/src/App.css`
export const DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT = DESKTOP_HEIGHT + TOP_AREA_BANNER_HEIGHT;
export const CSS_DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT = `var(${TOP_NAV_HEIGHT_CSS_VARIABLE}, ${DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT}px)`;
export const CSS_DESKTOP_WITH_TOP_AREA_BANNER_INNER_HEIGHT = `var(${TOP_NAV_INNER_HEIGHT_CSS_VARIABLE}, ${DESKTOP_HEIGHT}px)`;

// Must have the same value as ` --top-nav-height` and `--top-nav-inner-height` in `.top-nav--is-mobile` in `packages/top-area/src/App.css`
export const MOBILE_HEIGHT = 60;
export const MOBILE_INNER_HEIGHT = 60;
export const CSS_MOBILE_HEIGHT = `var(${TOP_NAV_HEIGHT_CSS_VARIABLE}, ${MOBILE_HEIGHT}px)`;
export const CSS_MOBILE_INNER_HEIGHT = `var(${TOP_NAV_INNER_HEIGHT_CSS_VARIABLE}, ${MOBILE_INNER_HEIGHT}px)`;

// Must have the same value as ` --top-nav-height` in `.top-nav--with-top-area-banner.top-nav--is-mobile` in `packages/top-area/src/App.css`
export const MOBILE_WITH_TOP_AREA_BANNER_HEIGHT = MOBILE_HEIGHT + TOP_AREA_BANNER_HEIGHT;
export const MOBILE_WITH_TOP_AREA_BANNER_INNER_HEIGHT = MOBILE_INNER_HEIGHT;
export const CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT = `var(${TOP_NAV_HEIGHT_CSS_VARIABLE}, ${MOBILE_WITH_TOP_AREA_BANNER_HEIGHT}px)`;
export const CSS_MOBILE_WITH_TOP_AREA_BANNER_INNER_HEIGHT = `var(${TOP_NAV_INNER_HEIGHT_CSS_VARIABLE}, ${MOBILE_WITH_TOP_AREA_BANNER_INNER_HEIGHT}px)`;

// Must have the same value as ` --top-nav-height` in `.top-nav--search-input-visible.top-nav--is-mobile` in `packages/top-area/src/App.css`
export const MOBILE_WITH_SEARCH_INPUT_HEIGHT = MOBILE_HEIGHT + SEARCH_INPUT_HEIGHT;
export const MOBILE_WITH_SEARCH_INPUT_INNER_HEIGHT = MOBILE_INNER_HEIGHT;
export const CSS_MOBILE_WITH_SEARCH_INPUT_HEIGHT = `var(${TOP_NAV_HEIGHT_CSS_VARIABLE}, ${MOBILE_WITH_SEARCH_INPUT_HEIGHT}px)`;
export const CSS_MOBILE_WITH_SEARCH_INPUT_INNER_HEIGHT = `var(${TOP_NAV_INNER_HEIGHT_CSS_VARIABLE}, ${MOBILE_WITH_SEARCH_INPUT_INNER_HEIGHT}px)`;

// Must have the same value as ` --top-nav-height` in `.top-nav--with-top-area-banner.top-nav--search-input-visible.top-nav--is-mobile` in `packages/top-area/src/App.css`
export const MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT =
  MOBILE_WITH_TOP_AREA_BANNER_HEIGHT + SEARCH_INPUT_HEIGHT;
export const MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_INNER_HEIGHT = MOBILE_WITH_TOP_AREA_BANNER_INNER_HEIGHT;
export const CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT = `var(${TOP_NAV_HEIGHT_CSS_VARIABLE}, ${MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT}px)`;
export const CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_INNER_HEIGHT = `var(${TOP_NAV_INNER_HEIGHT_CSS_VARIABLE}, ${MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_INNER_HEIGHT}px)`;

export const TOP_NAV_NO_SCROLL = 'top-nav--no-scroll';

/** @deprecated use DESKTOP_HEIGHT */
export const TOP_NAV_HEIGHT = DESKTOP_HEIGHT;
/** @deprecated use MOBILE_HEIGHT */
export const TOP_NAV_HEIGHT_MOBILE = MOBILE_HEIGHT;

export const AB_TASTY_SCRIPT_URL = 'https://try.abtasty.com/';
/**
 * AbTasty configuration ids.
 */
export const AB_TASTY_SCRIPT_IDS: Record<string, string> = {
  pl_live: 'd7969c131a7cd1e6eae1663545c12f7e',
  pl_stg: '8e82c73eacd1c73ed013bf7f9456f94d',
  ro_live: 'b9b95b18b302849d29466a1d6a271bd3',
  ro_stg: '45b6a9a02035d85e692125e9237ebc42',
  uk_live: '880cd51afa2ebc420d661463a5c7e851',
  uk_stg: 'de2ac2e90695e0f6a42150be9515d496',
};

export const AB_TASTY_SCRIPT_ID = 'abt';

// Graphql query limit for search preview products
export const SEARCH_PREVIEW_PRODUCTS_LIMIT = 12;
